import { useMemo } from 'react';
import { Select, SelectProps } from '@mantine/core';
import { COMPONENT_PROJECTS } from '../../config/componentProjects';

export type AdminComponentProjectFilterSelectProps = Omit<SelectProps, 'data'> & {
  value: string | null;
  onChange: (componentProjectId: string | null) => void;
  /** Restrict options to these project ids (e.g. after initiative lead filter). */
  allowedProjectIds?: string[] | null;
};

export function AdminComponentProjectFilterSelect({
  value,
  onChange,
  allowedProjectIds,
  disabled,
  style,
  styles: stylesProp,
  ...rest
}: AdminComponentProjectFilterSelectProps) {
  const data = useMemo(() => {
    let projects = [...COMPONENT_PROJECTS];
    if (allowedProjectIds && allowedProjectIds.length > 0) {
      const allowed = new Set(allowedProjectIds);
      projects = projects.filter((p) => allowed.has(p.id));
    }
    return projects
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((p) => ({
        value: p.id,
        label: p.name,
      }));
  }, [allowedProjectIds]);

  return (
    <Select
      label="Component project"
      placeholder="Select component project"
      required
      searchable
      clearable={false}
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxDropdownHeight={320}
      style={style}
      styles={stylesProp ?? {
        label: { marginBottom: '8px' },
        root: {
          '@media (max-width: 768px)': {
            width: '100%',
            minWidth: 'auto',
          },
        },
      }}
      {...rest}
    />
  );
}
